<!--
    @Author : Luo
    @Time   : 2020/8/8 17:05
-->
<template>
  <div class="pagination_container flex_center" v-if="length > 0">
    <div class="pagination_content flex_center">
      <div class="pagination_total">
        <span>共{{ length }}条</span>
      </div>
      <div class="pagination_list flex_center">
        <div class="pagination_tag pagination_prev flex_center" @click="prevArticle"><span>&lt;</span></div>
        <div class="pagination_main flex_center">
          <div class="pagination_tag" v-for="(item, i) in pagTotal"
              :key="i"
              :class="['flex_center', {'pagination_item_active': item === current}]"
              :data-key="item"
              @click="itemArticle(item)">
            <span>{{ item }}</span>
          </div>
        </div>
        <div class="pagination_tag pagination_prev flex_center" @click="nextArticle"><span>&gt;</span></div>
      </div>
      <div class="pagination_amount">
        <select @change="setPaginationAmount($event)" v-model="amount">
          <option value="10">{{ 10 }} 条/页</option>
          <option value="20">{{ 20 }} 条/页</option>
          <option value="30">{{ 30 }} 条/页</option>
          <option value="40">{{ 40 }} 条/页</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  data () {
    return {
      tempPagTotal: 0, // 总共分了多少页
      pagTotal: 0, // 当前分页总数据
      pagTotalLength: 5, // 当前分页显示10页
      current: 1, // 当前分页的下标
      amount: 0 // 每页显示多少条
    }
  },
  props: {
    // 数据的总长度
    length: {
      type: Number
    },
    // 默认每页显示的条数
    defaultAmount: {
      type: Number,
      value: 10
    },
    // 默认显示的页数
    defaultCurrent: {
      type: Number
    }
  },
  methods: {
    // 设置用户数据每页显示的条目
    setPaginationAmount: function (e) {
      let that = this

      that.current = 1
      that.amount = Number(e.currentTarget.value)
      that.tempPagTotal = Math.ceil(that.$props.length / that.amount)
      that.pagTotal = JSON.parse(JSON.stringify(that.tempPagTotal))
      that.pageCurrent('amount')
    },
    // 上一页点击
    prevArticle: function () {
      let that = this
      that.current = that.current - 1 <= 0 ? 1 : that.current - 1
      that.pageCurrent('article')
    },
    // 下一页点击
    nextArticle: function () {
      let that = this

      that.current = that.current + 1 >= that.tempPagTotal + 1 ? that.tempPagTotal : that.current + 1
      that.pageCurrent('article')
    },
    // 每一页点击
    itemArticle: function (e) {
      this.current = e
      this.pageCurrent('article')
    },
    // 传播事件
    pageCurrent: function (v) {
      let that = this
      that.pagTotal = that.setPagNeedDate(that.pagTotalLength, that.tempPagTotal, that.current)
      that.$emit('pageCurrent', {event: v, amount: that.amount, current: that.current, info: '每一页的点击'})
    },
    // 设置分页
    setPagNeedDate: function (p, l, c) {
      if (!p || !l || !c) return false
      p = p >= l ? l : p
      c = c <= 0 ? 1 : c
      c = c >= l ? l : c

      let m = Math.floor(p / 2) // 中位数
      let lt = 0 // 小于
      let gt = 0 // 大于
      let t = [] // 返回的数据
      let a = 0 // 开始循环的值

      if (c <= m) {
        a = 1
        gt = 1
        lt = p
      } else if (l - c <= m) {
        a = l
        gt = l - p + 1
        lt = 1
      } else {
        a = c
        gt = c - m
        lt = c + m
      }

      for (let i = a; i >= gt; i--) {
        t.push(i)
      }

      for (let i = a; i < lt; i++) {
        t.push(i + 1)
      }

      let b = 0 // 存储最小的值
      for (let i = 0; i < t.length - 1; i++) {
        b = 0
        for (let j = i + 1; j < t.length; j++) {
          if (t[i] > t[j]) {
            b = t[i]
            t[i] = t[j]
            t[j] = b
          }
        }
      }
      return t
    }
  },
  beforeMount () {
    let that = this

    that.amount = that.$props.defaultAmount
    that.current = that.$props.defaultCurrent
    that.tempPagTotal = Math.ceil(that.$props.length / that.amount)
    that.pagTotal = that.setPagNeedDate(that.pagTotalLength, that.tempPagTotal, that.current)
  }
}
</script>

<style scoped>
/* pagination */
.pagination_container {padding: 0 16px;margin-top: 30px;justify-content: flex-end}
.pagination_total span {font-size: 12px;font-weight: 500;color: rgba(96, 96, 96, 1)}
.pagination_list {margin-left: 16px}
.pagination_tag {cursor: pointer;margin-left: 8px;height: 32px;width: 38px;background-color: rgba(255, 255, 255, 1);border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px}
.pagination_list > div:first-of-type {margin-left: 0}
.pagination_tag:hover {border: 1px solid rgba(76, 139, 255, 1)}
.pagination_tag:hover span {color: rgba(76, 139, 255, 1)}
.pagination_list span {font-size: 12px;font-weight: 400;color: rgba(96, 96, 96, 1)}
.pagination_tag.pagination_item_active {background-color: rgba(76, 139, 255, 1);border: 1px solid rgba(76, 139, 255, 1)}
.pagination_tag.pagination_item_active span {color: rgba(255, 255, 255, 1)}
.pagination_tag.pagination_item_active:hover span {color: rgba(255, 255, 255, 1)}
.pagination_amount {margin-left: 8px}
.pagination_amount select {border: 1px solid rgba(219, 219, 219, 1);border-radius: 4px;padding: 0 30px 0 9px;height: 32px;font-size: 12px;font-weight: 500;color: rgba(96, 96, 96, 1)}
</style>



// WEBPACK FOOTER //
// src/components/pagination/index.vue